import {useMemo} from 'react'
import type {
  EstablishedAhpSession,
  EstablishedAhpSessionIntegrationServices,
  EstablishedAhpSessionIntegrations,
} from '@github-ui/ahp-session-client/contracts'

import {useEstablishedAhpSession} from './use-established-ahp-session'

export function getEstablishedAhpSessionIntegrations(
  session: EstablishedAhpSession,
): EstablishedAhpSessionIntegrations {
  return {
    view: session.view,
    input: session.input,
    commands: session.commands,
    lifecycle: session.lifecycle,
    ...(session.planning ? {planning: session.planning} : {}),
  }
}

export function useEstablishedAhpSessionIntegrations(
  services?: EstablishedAhpSessionIntegrationServices,
): EstablishedAhpSessionIntegrations {
  const session = useEstablishedAhpSession()
  return useMemo(() => ({...getEstablishedAhpSessionIntegrations(session), ...services}), [services, session])
}
